import {
  createTheme as createThemeMui,
  ThemeOptions,
  PaletteOptions,
} from '@mui/material/styles';

import { lightPalette } from './foundations/lightPalette';
import { darkPalette } from './foundations/darkPalette';
import { breakpoints } from './foundations/breakpoints';
import { MuiTypography } from './components/MuiTypography';

const allowDarkMode = false;
export const prefersDarkMode =
  window.matchMedia('(prefers-color-scheme: dark)').matches && allowDarkMode;

export function createTheme() {
  const palette: PaletteOptions = {
    ...(prefersDarkMode && allowDarkMode ? darkPalette : lightPalette),
  };

  const options: ThemeOptions = {
    breakpoints,
    palette,
    components: {
      MuiTypography: MuiTypography(palette),
    },
  };

  return createThemeMui(options);
}

export const theme = createTheme();
export default theme;
